/* Seac Sustentavel - JS das secoes custom
   1) Botão comprar -> adiciona ao carrinho via AJAX e abre o drawer do Dawn
   2) Calculadora de economia
*/
(function () {
  'use strict';

  /* ---------- Comprar -> drawer ---------- */
  function bindBuyButtons() {
    document.querySelectorAll('form[data-seac-buy]').forEach(function (form) {
      if (form.dataset.seacBound) return;
      form.dataset.seacBound = '1';
      form.addEventListener('submit', async function (e) {
        var variantId = form.querySelector('[name="id"]');
        // Sem produto/variante configurado -> deixa o link/comportamento padrão
        if (!variantId || !variantId.value) return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.innerHTML : '';
        if (btn) { btn.disabled = true; btn.innerHTML = 'Adicionando…'; }

        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: Number(variantId.value), quantity: 1 }] };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e2) {}
          body.sections_url = window.location.pathname;
        }
        try {
          var res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
            body: JSON.stringify(body)
          });
          var data = await res.json();
          if (res.status !== 200) throw new Error(data.description || 'Erro ao adicionar');
          if (drawer && typeof drawer.renderContents === 'function') {
            drawer.classList.remove('is-empty');
            drawer.renderContents(data);
            if (typeof drawer.open === 'function') drawer.open();
          } else {
            window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
          }
        } catch (err) {
          console.error('[seac] add to cart', err);
          window.location.href = (window.routes && window.routes.cart_url) ? window.routes.cart_url : '/cart';
        } finally {
          if (btn) { btn.disabled = false; btn.innerHTML = label; }
        }
      });
    });
  }

  /* ---------- Calculadora de economia ---------- */
  function brl(v) {
    return v.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }
  function bindCalculators() {
    document.querySelectorAll('[data-seac-calc]').forEach(function (root) {
      if (root.dataset.seacBound) return;
      root.dataset.seacBound = '1';
      // Faixa de economia (brief 8.5): percentualMin (padrão 20) e percentualMax (padrão 50)
      var pMin = Math.min(Math.max(parseFloat(root.dataset.pctMin || '20'), 1), 100);
      var pMax = Math.min(Math.max(parseFloat(root.dataset.pctMax || '50'), 1), 100);
      if (pMax < pMin) { var sw = pMin; pMin = pMax; pMax = sw; }
      var input = root.querySelector('[data-calc-input]');
      var range = root.querySelector('[data-calc-range]');
      function setAll(sel, text) { root.querySelectorAll(sel).forEach(function (e) { e.textContent = text; }); }

      function render(val) {
        val = isNaN(val) || val < 0 ? 0 : val;
        var min = val * (pMin / 100);
        var max = val * (pMax / 100);
        setAll('[data-calc-min]', brl(min));
        setAll('[data-calc-max]', brl(max));
        setAll('[data-calc-annual]', brl(max * 12));
      }
      function sync(val) {
        if (input) input.value = val;
        if (range) range.value = val;
        render(val);
      }
      if (input) input.addEventListener('input', function () { var v = parseFloat(input.value); if (range && !isNaN(v)) range.value = Math.min(v, range.max); render(v); });
      if (range) range.addEventListener('input', function () { sync(parseFloat(range.value)); });
      sync(parseFloat((input && input.value) || (range && range.value) || 150));
    });
  }

  /* ---------- Galeria (troca imagem principal) ---------- */
  function bindGalleries() {
    document.querySelectorAll('[data-seac-gallery]').forEach(function (g) {
      if (g.dataset.seacBound) return;
      g.dataset.seacBound = '1';
      var main = g.querySelector('.seac-gallery__main');
      g.querySelectorAll('.seac-gallery__thumb').forEach(function (t) {
        t.addEventListener('click', function () {
          var src = t.getAttribute('data-src');
          if (!src || !main) return;
          main.src = src;
          g.querySelectorAll('.seac-gallery__thumb').forEach(function (x) { x.classList.remove('is-active'); });
          t.classList.add('is-active');
        });
      });
    });
  }

  /* ---------- Upsell no cart drawer (adicionar mais unidades) ---------- */
  function bindUpsell() {
    if (document._seacUpsellBound) return;
    document._seacUpsellBound = true;
    document.addEventListener('click', async function (e) {
      var btn = e.target.closest && e.target.closest('[data-seac-add-unit]');
      if (!btn) return;
      e.preventDefault();
      var vid = btn.getAttribute('data-variant');
      if (!vid) return;
      var drawer = document.querySelector('cart-drawer');
      var label = btn.innerHTML;
      btn.disabled = true; btn.innerHTML = 'Adicionando…';
      var body = { items: [{ id: Number(vid), quantity: 1 }] };
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try { body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }); } catch (e2) {}
        body.sections_url = window.location.pathname;
      }
      try {
        var res = await fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' }, body: JSON.stringify(body)
        });
        var data = await res.json();
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
        } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
      } catch (err) { console.error('[seac] upsell', err); }
      finally { btn.disabled = false; btn.innerHTML = label; }
    });
  }

  /* ---------- Barra fixa de comprar (sticky) ---------- */
  function bindSticky() {
    var el = document.querySelector('[data-seac-sticky]');
    if (!el || el._seacBound) return;
    el._seacBound = true;
    function onScroll() {
      if (window.scrollY > 600) el.classList.add('is-visible');
      else el.classList.remove('is-visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function init() { bindBuyButtons(); bindCalculators(); bindGalleries(); bindUpsell(); bindSticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Re-bind quando o customizer recarrega uma seção
  document.addEventListener('shopify:section:load', init);
})();
